<div class="public-content">
    <div class="public-text">
        <img src="../../../assets/images/logo-icon-dark.svg" style="width: 300px; height: auto;" alt="logo">
    </div>
    <div class="public-form">
        <div *ngIf="!isTokenValid && !isAlreadyUnsubscribed" style="color: white;">
            <div>You have successfully unsubscribed and will no longer receive notifications for this alert.</div>
        </div>
        <div *ngIf="!isTokenValid && isAlreadyUnsubscribed" style="color: white;">
            <div>You have already  unsubscribed the  notifications for this alert.</div>
        </div>
        <form [formGroup]="unsubscribeAlertForm" *ngIf="isTokenValid" (ngSubmit)="onSubmit()">

            <div style="margin-bottom: 10px; font-size: 0.90rem; color: #FFFFFF;
                        text-align: center; text-transform: capitalize; cursor: pointer;">
            Are you sure you want to unsubscribe from this notification? You will stop receiving further emails related to this alert.</div>
            <!-- <mat-form-field style="border-radius: 1px;
            padding: 0.234rem 0.375rem 0.313rem 0.312rem;
            height: 2.5rem;"> -->
                <textarea matInput
                          autocomplete="off"
                          formControlName="reason"
                          rows="4"
                          placeholder="Enter your reason"
                          style="height: auto; background-color: white; padding: 10px;">
                </textarea>
              <!-- </mat-form-field> -->
            <button mat-stroked-button color="primary" style="margin-top: 10px;">Submit</button>
        </form>
    </div>
</div>
